import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import ButtonTypes from 'components/Button/Button.const';

import CONTENT_TYPES from 'globalConst/contentTypes-const';
import FAVORITE_HOVER_TITLES from './ToggleFavoriteButton.const';
import Favourite from '../svg/Favourite';
import { isMobile } from 'util/device';

/**
 * Toggle Favorites
 * @param {string} type
 * @param {object} item
 * @param {boolean} isFavorite
 * @param {function} toggleFavorite
 */

const ToggleFavoriteButton = ({ item, isFavorite, toggleFavorite, ...restProps }) => {
  if (isMobile) {
    return null;
  }

  function toggle(e) {
    e.stopPropagation();

    toggleFavorite(item);
  }

  let title;
  switch (item.contentTypeId) {
    case 'clip':
      title = isFavorite ? FAVORITE_HOVER_TITLES.CLIP[1] : FAVORITE_HOVER_TITLES.CLIP[0];
      break;
    default:
      title = null;
  }

  return (
    <Button
      onClick={toggle}
      title={title}
      type={ButtonTypes.ICON}
      icon={<Favourite isActive={isFavorite} />}
      data-testid={`favorite-btn-${isFavorite ? 'active' : 'inactive'}`}
      {...restProps}
    />
  );
};

ToggleFavoriteButton.defaultProps = {
  isFavorite: false,
};

ToggleFavoriteButton.propTypes = {
  toggleFavorite: PropTypes.func.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    contentTypeId: PropTypes.oneOf(Object.values(CONTENT_TYPES)).isRequired,
    slug: PropTypes.string,
  }).isRequired,
  isFavorite: PropTypes.bool,
};

ToggleFavoriteButton.displayName = 'ToggleFavoriteButton';

export default ToggleFavoriteButton;
